import { render, staticRenderFns } from "./TabCme.vue?vue&type=template&id=5ff74130&scoped=true&"
import script from "./TabCme.vue?vue&type=script&lang=js&"
export * from "./TabCme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff74130",
  null
  
)

export default component.exports